export default __webpack_public_path__ + "static/media/go-to-portfolio-icon.5d7f4528.png";